<template>
  <v-tabs light background-color="white" show-arrows>
    <v-tabs-slider color="primary lighten-3"></v-tabs-slider>
    <v-tab v-for="(item,i) in brands" :key="i" :href="item.url">
      <img :src="item.logo"/>
    </v-tab>
  </v-tabs>  
</template>

<script>
  export default {
    name: 'Brands',
    data(){
      return {
      }
    },
    methods:{
    },
    computed:{
      brands() {
        return this.$store.state.brands;
      }
    },
    mounted: function () {
    },
    created() {
    }
  }
</script>